import style from "./mainPartnership.module.scss";
import {useEffect, useRef} from "react";
import {PartnerField} from "./PartnerField";
import {PartnerTitleField} from "./PartnerTitleField";
import {useLanguage} from "../../../hooks/hooks";
import {useTranslation} from "react-i18next";
import {usePartnershipFunctions} from "./hooks/usePartnershipFunctions";

export function MainPartnership() {
    const { isKorean } = useLanguage();
    const { t } = useTranslation("brand");

    const domesticContainerRef = useRef<HTMLDivElement>(null);
    const domesticWrapperRef = useRef<HTMLDivElement>(null);

    const overseasContainerRef = useRef<HTMLDivElement>(null);
    const overseasWrapperRef = useRef<HTMLDivElement>(null);

    const {
        calculateOverflow,
        waitForImagesAndCalculate,
        isDomesticOverflowing, isOverseasOverflowing,
        domesticAnimationDuration, overseasAnimationDuration,
        domesticPartnerCompanies, overseasPartnerCompanies
    } = usePartnershipFunctions(
        { domesticContainerRef, domesticWrapperRef, overseasContainerRef, overseasWrapperRef}
    )

    // 창 크기가 변경될 때 오버플로우 다시 계산
    useEffect(() => {
        const handleResize = () => {
            calculateOverflow();
        };

        window.addEventListener('resize', handleResize);

        const timer = setTimeout(calculateOverflow, 300);
        return () => {
            window.removeEventListener('resize', handleResize);
            clearTimeout(timer);
        };
    }, [calculateOverflow, isKorean]);

    useEffect(() => {
        if (domesticPartnerCompanies || overseasPartnerCompanies) {
            // 이미지 로드 확인 및 계산 실행
            waitForImagesAndCalculate();

            // 일정 시간 후 다시 한번 계산 (안전장치)
            const timer = setTimeout(calculateOverflow, 1000);

            return () => {
                clearTimeout(timer);
            };
        }
    }, [domesticPartnerCompanies, overseasPartnerCompanies, calculateOverflow, waitForImagesAndCalculate]);

    return (
        <div className={style.partnerWrapper}>
            <PartnerTitleField />

            <div>
                {isKorean && (
                <PartnerField
                    title={"K-PASS 검사 국내 협력사"} detail={"국내 협력사 상세보기"}
                    partnerCompany={domesticPartnerCompanies}
                    mainRef={domesticContainerRef} compareRef={domesticWrapperRef}
                    animationDuration={domesticAnimationDuration}
                    isOverflowing={isDomesticOverflowing}/>
                )}

                <PartnerField
                    title={t('partner.overseaPartner.title')} detail={"해외 협력사 상세보기"}
                    partnerCompany={overseasPartnerCompanies}
                    mainRef={overseasContainerRef} compareRef={overseasWrapperRef}
                    animationDuration={overseasAnimationDuration}
                    isOverflowing={isOverseasOverflowing}/>
            </div>
        </div>
    );
}